const { createApp, h } = Vue
const rootEl = document.getElementById('productApp');
const apiCanvasComponent = {
    data() {
        return {}
    },
    props: {
        image: Object,
        mural: Object
    },
    watch: {
        'image': {
            handler(newValue, oldValue) {
                this.update();
            },
            deep: true
        },
        'mural': {
            handler(newValue, oldValue) {
                this.update();
            },
            deep: true
        },
    },
    mounted () {
        this.update();
    },
    methods: {
        update() {
            const ctx = this.$refs.canvas.getContext("2d");
            const bg = new Image();
            const dmi = new Image();
            const bgPromise = new Promise((resolve, reject) => {
                bg.addEventListener('load', (e) => {
                    resolve();
                });
                bg.src = this.mural.url;
            });
            const dmiPromise = new Promise((resolve, reject) => {
                dmi.addEventListener('load', (e) => {
                    resolve();
                });
                dmi.src = this.image.src;
            });
            Promise.all([bgPromise, dmiPromise]).then((values) => {
                let dx = this.image.dx || 0;
                let dy = this.image.dy || 0;
                let bgWidth = this.image.dWidth || this.image.width;
                let bgHeight = this.image.dHeight || this.image.height;
                if(this.mural.orientation === 'panoramic' || this.mural.orientation === 'vertical') {
                    let imageWidth = bg.width;
                    let imageHeight = bg.height;
                    if(this.mural.orientation === 'panoramic') {
                        if(imageHeight !== bgHeight) {
                            imageHeight = bgHeight;
                            imageWidth = imageHeight * this.mural.ratio;
                            dx = (((imageWidth - bgWidth) / 2) * -1) + dx;
                        }
                    }
                    if(this.mural.orientation === 'vertical') {
                        if(imageWidth !== bgWidth) {
                            imageWidth = bgWidth;
                            imageHeight = imageWidth / this.mural.ratio;
                            dy = (((imageHeight - bgHeight) / 2) * -1) + dy;
                        }
                    }
                    bgHeight = imageHeight;
                    bgWidth = imageWidth;
                }
                if(this.mural.orientation === 'square' || this.mural.orientation === 'horizontal') {
                    let imageWidth = bg.width;
                    let imageHeight = bg.height;
                    if(imageHeight !== bgHeight) {
                        imageHeight = bgHeight;
                        imageWidth = imageHeight * this.mural.ratio;
                    }
                    if(imageWidth < bgWidth) {
                        imageWidth = bgWidth;
                        imageHeight = imageWidth / this.mural.ratio;

                    }
                    dx = (((imageWidth - bgWidth) / 2) * -1) + dx;
                    dy = (((imageHeight - bgHeight) / 2) * -1) + dy;
                    bgHeight = imageHeight;
                    bgWidth = imageWidth;
                }

                // draw mural
                ctx.drawImage(bg,dx,dy,bgWidth,bgHeight);
                // draw room
                ctx.drawImage(dmi,0,0,this.image.width,this.image.height);
            });
        }
    },
    template: `<canvas :id="image.canvasId" ref="canvas" :width="image.width" :height="image.height"></canvas>`
}
const apiImageComponent = {
    components: {
        'api-canvas': apiCanvasComponent,
    },
    data() {
        return {
            apiImage: null,
            isApi: true,
            loading: false
        }
    },
    props: {
        item: Object,
        shopify: Object,
        startingImage: Number,
        images: Array,
        panels: Number
    },
    inject: ['height','hide','uploading','uploaded','materials'],
    created() {
        if(this.item && this.item.hasOwnProperty('url')) {
            if(this.item.update === true) {
                this.loading = true
                if(sessionStorage.getItem('adobe-image-'+this.item.id)) {
                    const storedImage = sessionStorage.getItem('adobe-image-'+this.item.id);
                    setTimeout(() => {
                        this.$emit('downloadImage',storedImage);
                        this.loading = false;
                    },150);
                } else {
                let url = this.remoteApiUrl + 'shopify/api/download?id='+this.item.id;
                axios.get(url).then((response) => {
                    if(response.data && response.data.url) {
                            sessionStorage.setItem('adobe-image-'+this.item.id, response.data.url);
                            this.$emit('downloadImage',response.data.url);
                    }
                }).finally(() => {
                    this.loading = false;
                });
            }
            }
        } else {
            this.isApi = false
        }
    },
    emits: ['changeImage','openQuickview','downloadImage'],
    computed: {
        currentImage() {
            if(this.startingImage !== null
                && this.startingImage >= 0
                && this.startingImage < this.images.length) {
                return this.images[this.startingImage];
            }
        },
        imageClass() {
            return {
                'loading': this.loading || this.uploading,
                'custom-image-uploaded': this.uploaded,
                'vertical': this.item.ratio <= 0.7,
                'square': this.item.ratio > 0.7 && this.item.ratio <= 1.3,
                'horizontal': this.item.ratio > 1.3 && this.item.ratio < 2,
                'panoramic': this.item.ratio >= 2,
                ['panels-' + this.panels]: this.panels && this.panels > 1
            }
        },
        isCustom() {
            return this.item.custom || this.item.size === 'custom';
        },
        getImageUrl() {
            return this.isApi ? (this.item.upload ? this.item.upload : this.item.url) : this.shopify.featured_image
        },
        previewImageUrl() {
            return window.previewImageUrl;
        },
        customStaticImages() {
            //return this.getImageUrl === this.previewImageUrl ? this.images.filter((image) => !image.hasOwnProperty('canvasId')) : this.images;
            return this.item.custom && this.images.length > 0 && this.getImageUrl === this.previewImageUrl ?
                [...this.images.keys()]
                    .filter((key) => this.images[key].hasOwnProperty('canvasId') === false)
                    .reduce((acc, key) => {
                        acc[key] = this.images[key];
                        return acc;
                    }, []) :
                this.images;
        }
    },
    methods: {
        open() {
            this.$emit('openQuickview')
        },
        nextImage() {
            let active = this.startingImage + 1;
            if(active >= this.images.length) {
                active = 0;
            } else if(this.isCustom && !this.customStaticImages[active]) {
                // find the key of next non empty item in this.customStaticImages and assign it to "active"
                active = [...this.customStaticImages.keys()]
                    .filter((key) => this.customStaticImages[key])
                    .reduce((acc, key) => {
                        if (key > active && (acc === null || key < acc)) {
                            return key;
                        }
                        return acc;
                    }, null);
            }
            this.activateImage(active);
        },
        prevImage() {
            let active = this.startingImage - 1;
            if(active < 0) {
                active = this.images.length - 1;
            } else if(this.isCustom && !this.customStaticImages[active]) {
                // find the key of the prev non empty item in this.customStaticImages and assign it to "active"
                active = [...this.customStaticImages.keys()]
                    .filter((key) => this.customStaticImages[key])
                    .reduce((acc, key) => {
                        if(key < active && (acc === null || key > acc)) {
                            return key;
                        }
                        return acc;
                    }, null);
            }
            this.activateImage(active);
        },
        activateImage(imageIndex) {
            this.$emit('changeImage', imageIndex);
        },
        triggerImageUpload() {
            const imageUploadInput = document.getElementById('image_upload');
            if (imageUploadInput) {
                imageUploadInput.click();  
            } 
        }
    },
    template: `
        <div class="product-thumbs" id="thumbnails-wrapper" :class="{'disable-thumbs': item.size === 'custom'}">
            <ul class="slick-dots">
                <template v-for="(image, index) in customStaticImages">
                <li :class="{'slick-active':index === this.startingImage}" v-if="image">
                    <a href="#" @click.prevent="activateImage(index)">
                    <template v-if="image.hasOwnProperty('canvasId')"><api-canvas :image="image" :mural="item"></api-canvas></template>
                    <img v-else :src="image.src" class="product-thumb">
                    </a>
                </li>
                </template>
            </ul>
        </div>
        <div class="product-main-img" :class="imageClass">
            <div class="product-image" :class="imageClass" v-if="item.size === 'custom'">
                <img :src="getImageUrl" alt="" class="" id="product-image" v-show="!hide" :width="getImageUrl === previewImageUrl ? '665' : null" :height="getImageUrl === previewImageUrl ? '443' : null">
            </div>
            <div v-else class="gallery-wrapper slick-initialized slick-slider slick-dotted">
                <button v-if="images && images.length > 1" type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" role="button" @click.prevent="prevImage()">Previous</button>
                <div class="item">
                    <template v-if="currentImage.hasOwnProperty('canvasId')"><api-canvas :image="currentImage" :mural="item"></api-canvas></template>
                    <img v-else class="img-responsive" alt="" :src="currentImage.src">
                    <div class="upload-image-btn" v-if="item.custom && currentImage.src === previewImageUrl" @click="triggerImageUpload()"></div>
                    <a href="#" class="quickview" @click.prevent="open" v-if="!item.custom && startingImage === 0">View Larger</a>
                    <span class="cropper-panels" id="gallery-panels" v-if="!item.custom && startingImage === 0 && this.panels > 1"><span v-for="n in (this.panels - 1)"></span></span>
                </div>
                <button v-if="images && images.length > 1" type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" role="button" @click.prevent="nextImage()">Next</button>
            </div>
        </div>`,
}
const productApp = Vue.createApp({
    components: {
        'api-image': apiImageComponent,
        'api-canvas': apiCanvasComponent,
        'api-similar-works': SimilarWorks,
        'wishlistlink': wishlistLink,
        'faqs': Faqs,
        'materials-compare': materialsModalCompare
        // 'additional-info': AdditionalInfo
    },
    data() {
        return {
            items: [],
            item: null,
            shopify: {},
            materials: {},
            variant: null,
            materialTab: 'Peel & Stick',
            instructionsOpen: false,
            tabs: {
                "shipping": {
                    "collapsed": true
                },
                "installation": {
                    "collapsed": true
                }
            },
            cropperEnabled: true,
            cropperAdapter: null,
            productImage: null,
            imageWidth: 0,
            imageHeight: 0,
            imageRatio: 0,
            customSizes: {},
            sizesUpdated: 0,
            loading: false,
            loaded: false,
            errors: {},
            files: null,
            croppedFiles: null,
            croppedBlob: null,
            copyright: true,
            imageContainerHeight: 0,
            imageHide: false,
            imageUploading: false,
            imageUploaded: false,
            downloadInterval: null,
            materialsModalOpen: false,
            hasSampleImage: true,
            selectedImage: 0,
            discount: (this.partnerDiscount && window.customerIsPartner) ? this.partnerDiscount : this.autoDiscount,
            staticImages: [],
            cropCoordinates: {
                'imageWidth': 0,
                'imageHeight': 0,
                'left': 0,
                'top': 0,
                'croppedWidth': 0,
                'croppedHeight': 0,
                'flippedHorizontally': false,
            }
        }
    },
    props: ['type','autoDiscount','partnerDiscount'],
    provide() {
        return {
            height: Vue.computed(() => this.imageContainerHeight > 0 ? this.imageContainerHeight + 'px' : 'auto'),
            hide: Vue.computed(() => this.imageHide),
            uploading: Vue.computed(() => this.imageUploading),
            uploaded: Vue.computed(() => this.imageUploaded),
            materials: Vue.computed(() => this.materials)
        }
    },
    created() {
        this.cartNotification = document.querySelector('cart-notification');
        this.getShopifyData()
        this.getItem()
    },
    mounted () {
        this.observePdp();
        this.initProductImage();
    },
    computed: {
        price() {
            const topcoat = this.item.options.topcoat ? "Add a Protective Topcoat" : "None";
            const variantSize = this.qty >= 37 ? "37" : "0";
            this.variant = this.shopify.variants.find((variant) => {
                return (
                    variant.option1.indexOf(this.item.material) === 0 &&
                    variant.option2 === topcoat &&
                    variant.option3 === variantSize
                );
            })
            return this.variant.price * this.qty * 144;
        },
        correctedPrice() {
            return this.price >= this.minPrice ? this.price : this.minPrice;
        },
        specialPrice() {
            return this.correctedPrice * (1 - (Number(this.discount) / 100));
        },
        qty() {
            return Math.round((this.item.width.feet + this.item.width.inches/12)*(this.item.height.feet + this.item.height.inches/12));
        },
        materialPrices() {
            const prices = {};
            if(this.item && this.materials.length > 0) {
                this.materials.forEach((material) => {
                    const topcoat = this.item.options.topcoat ? "Add a Protective Topcoat" : "None";
                    const variantSize = this.qty >= 37 ? "37" : "0";
                    const variant = this.shopify.variants.find((v) => {
                        return (
                            v.option1.indexOf(material.label) === 0 &&
                            v.option2 === topcoat &&
                            v.option3 === variantSize
                        );
                    });
                    if(variant) {
                        const price = variant.price * this.qty * 144;
                        prices[material.code] = {
                            'price': price >= this.minPrice ? price : this.minPrice
                        };
                        if(Number(this.discount) > 0) {
                            prices[material.code]['special'] = prices[material.code]['price'] * (1 - (Number(this.discount) / 100));
                            prices[material.code]['discount'] = `${this.discount}% off`;
                        }
                    }
                })
            }
            return prices;
        },
        cartLoading() {
            return store.getters['cartPopup/loading'];
        },
        customWidth() {
            return this.item.sizes['custom'].width.feet * 12 + this.item.sizes['custom'].width.inches * 1;
        },
        customHeight() {
            return this.item.sizes['custom'].height.feet * 12 + this.item.sizes['custom'].height.inches * 1;
        },
        maxLength() {
            return Math.max(this.customWidth, this.customHeight);
        },
        minLength() {
            return Math.min(this.customWidth, this.customHeight);
        },
        images() {
            let imgs = []
            if(this.item && this.item.url && this.item.orientation && this.muralDMI.hasOwnProperty(this.item.orientation)) {
                imgs.push({'src':this.item.url});
                if(this.item.custom) {
                    imgs.push(this.muralDMI[this.item.orientation][0]);
                } else {
                imgs = imgs.concat(this.muralDMI[this.item.orientation]);
            }
                for (const image of this.staticImages[this.item.orientation]) {
                    imgs.push({'src':image.src});
                }
            }
            return imgs
        },
        showComparePopup() {
            return store.getters['modal/showComparePopup'];
        },
        panels() {
            const width = this.item && this.item.sizes && this.item.sizes.custom && this.item.sizes.custom.width && this.item.sizes.custom.width.feet !== null && this.item.sizes.custom.width.inches !== null ? this.item.sizes.custom.width.feet * 12 + this.item.sizes.custom.width.inches : 0;
            const height = this.item && this.item.sizes && this.item.sizes.custom && this.item.sizes.custom.height && this.item.sizes.custom.height.feet !== null && this.item.sizes.custom.height.inches !== null ? this.item.sizes.custom.height.feet * 12 + this.item.sizes.custom.height.inches : 0;
            if(width <= 0 || height <= 0) {
                return 0;
            }
            const material = this.item.material ? this.materials.find(m=> m.label === this.item.material) : null;
            if(!material || !material.panel) {
                return 0;
            }
            if(width <= material.panel || height <= material.panel) {
                return 0;
            }
            let panels = Math.ceil(width / material.panel);
            if(panels < 2) {
                return 0;
            }
            return panels;
        }
    },
    watch: {
        'item.size': {
            handler(newValue, oldValue) {
                this.errors = {};
                this.item.width = this.item.sizes[newValue].width;
                this.item.height = this.item.sizes[newValue].height;
                this.resizeImage();
            },
            deep: true
        },
        'item.sizes': {
            handler(newValue, oldValue) {
                this.resizeImage();
            },
            deep: true
        },
        'item.material': {
            handler(newValue, oldValue) {
                this.resizeImage();
            },
            deep: true
        },
        materialsModalOpen(newState,oldState) {
            if(newState) {
                document.body.classList.add('overflow-hidden')
            } else {
                document.body.classList.remove('overflow-hidden')
            }
        },
        showComparePopup(newState,oldState) {
            if(newState) {
                document.body.classList.add('overflow-hidden', 'compare-modal-open')
            } else {
                document.body.classList.remove('overflow-hidden', 'compare-modal-open')
            }
        },
        loaded(newValue, oldValue) {
            if(newValue === true) {
                this.getStaticImages()
            }
        },
    },
    methods: {
        initProductImage() {
            if(!this.downloadInterval) {
                this.downloadInterval = setInterval(() => {
                    if(document.getElementById('product-image')) {
                        clearInterval(this.downloadInterval);
                        this.productImage = document.getElementById('product-image');
                        this.cropperAdapter = new LimitlessCropper(jQuery(this.productImage));
                        if (this.productImage.complete && this.productImage.naturalWidth !== 0) {
                            this.imageWidth = this.productImage.naturalWidth;
                            this.imageHeight = this.productImage.naturalHeight;
                            this.imageRatio = this.imageWidth / this.imageHeight;
                        } else {
                            this.productImage.addEventListener('load', () => {
                                this.imageWidth = this.productImage.naturalWidth;
                                this.imageHeight = this.productImage.naturalHeight;
                                this.imageRatio = this.imageWidth / this.imageHeight;
                            });
                        }

                        window.addEventListener('destroyCropper', (event) => {
                            this.cropperAdapter.destroy();
                            this.resetCoordinates();
                            if(!this.item.custom) {
                                document.getElementById('cropped-image').value = '';
                                this.croppedBlob = null;
                                this.croppedFiles = null;
                            }
                        });

                        window.addEventListener('initCropper', (event) => {
                            this.loading = true;
                            this.item.options.bw = false;
                            this.item.options.flip = false;
                            setTimeout(() => {
                                this.cropperAdapter.init(event.detail,{'imageRatio':this.imageRatio, 'imageWidth':this.imageWidth, 'imageHeight':this.imageHeight});
                                this.loading = false;
                            }, 250);
                        });

                        window.addEventListener('replaceCropper', (event) => {
                            this.loading = true;
                            setTimeout(() => {
                                this.cropperAdapter.replace(event.detail);
                                this.loading = false;
                            }, 250)
                        });

                        this.productImage.addEventListener('cropper.created', (event) => {
                            this.loading = true;
                            setTimeout(() => {
                                if(this.sizesUpdated === 1) {
                                    this.sizesUpdated = 0;
                                    this.cropperAdapter.updateForUserDimensions(this.customSizes);
                                }
                                if(this.item.options.flip) {
                                    this.cropperAdapter.flip();
                                }
                                this.loading = false;
                            }, 500)
                        });

                        this.productImage.addEventListener('image.updated', (event) => {
                            this.loading = true;
                            setTimeout(() => {
                                const imageData = this.cropperAdapter.getImageData();
                                if(imageData) {
                                    document.getElementById('cropped-image').value = imageData.toDataURL('image/jpeg');
                                    this.generateCroppedImage(imageData).finally(() => {
                                        this.loading = false;
                                        const cropperData = this.cropperAdapter.getData();
                                        this.cropCoordinates = {
                                            'imageWidth': this.imageWidth,
                                            'imageHeight': this.imageHeight,
                                            'left': Math.round(cropperData.x),
                                            'top': Math.round(cropperData.y),
                                            'croppedWidth': Math.round(cropperData.width),
                                            'croppedHeight': Math.round(cropperData.height),
                                            'flippedHorizontally': cropperData.scaleX == -1 ? true : false,
                                        }
                                    })
                                } else {
                                    this.loading = false;
                                }
                            }, 750)
                        });

                        window.addEventListener('resizeCropper', (event) => {
                            this.resizeImage();
                        });
                    }
                },500);
            }
        },
        resetCoordinates() {
            this.cropCoordinates = {
                'imageWidth': 0,
                'imageHeight': 0,
                'left': 0,
                'top': 0,
                'croppedWidth': 0,
                'croppedHeight': 0,
                'flippedHorizontally': false,
            }
        },
        generateCroppedImage(imageData) {
            return new Promise((resolve, reject) => {
                const fileName = Math.random().toString(36).slice(2) + '.png';
                imageData.toBlob((blob) => {
                    this.croppedBlob = blob;
                    this.croppedFiles = new File([blob], fileName, { type: "image/png" });
                    this.hasSampleImage = true;
                    resolve();
                }, 'image/png')
            })
        },
        resizeImage() {
            this.loading = true;
            this.selectedImage = 0;
            setTimeout(() => {
                if(this.item.size === 'custom') {
                    if((this.item.sizes['custom'].height.feet > 0 || this.item.sizes['custom'].height.inches > 0) &&
                        (this.item.sizes['custom'].width.feet > 0 || this.item.sizes['custom'].width.inches > 0)) {
                        const customWidth = this.item.sizes['custom'].width.feet * 12 + this.item.sizes['custom'].width.inches * 1;
                        const customHeight = this.item.sizes['custom'].height.feet * 12 + this.item.sizes['custom'].height.inches * 1;
                        const customSizeRatio = customWidth / customHeight;
                        this.sizesUpdated = 1;
                        this.customSizes = {'customRatio': customSizeRatio, 'customWidth': customWidth, 'customHeight': customHeight, 'panels': this.panels };
                        const event = new CustomEvent("initCropper", {detail: { 'customRatio': customSizeRatio, 'customWidth': customWidth, 'customHeight': customHeight, 'panels': this.panels }});
                        window.dispatchEvent(event);
                    } else {
                        const event = new CustomEvent("destroyCropper");
                        window.dispatchEvent(event);
                    }
                } else {
                    const event = new CustomEvent("destroyCropper");
                    window.dispatchEvent(event);
                }
                this.loading = false;
            },500)
        },
        onUpload(e) {
            this.files = e.target.files || e.dataTransfer.files;
            this.imagePreview();
        },
        imagePreview() {
            const resizer = window.pica();
            const supportedFormats = ['image/jpeg','image/jpg','image/gif','image/png','application/pdf'];
            const imageFormats = ['image/jpeg','image/jpg','image/gif','image/png'];
            const maxSize = 20971520; // 20Mb
            if (this.files && this.files[0]) {
                const uploaded = this.files[0];
                const errorContainer = document.querySelector('.input-error');
                const messageContainer = document.querySelector('.input-message');
                if(!supportedFormats.includes(uploaded.type)) {
                    errorContainer.innerHTML = `This online uploader only accepts png, gif, and jpeg files. Please contact <a href="mailto:info@limitlesswalls.com">info@limitlesswalls.com</a> for assistance with any other file types.`;
                    errorContainer.style.display = 'block';  
                    messageContainer.innerHTML = '';
                    messageContainer.style.display = 'none';
                    return false;
                } else {
                    errorContainer.style.display = 'none'; 
                }
                if(uploaded.size > maxSize) {
                     errorContainer.innerHTML = `File size exceeds our 20mb max. Please send file via email to <a href="mailto:info@limitlesswalls.com">info@limitlesswalls.com</a>.`;
                     errorContainer.style.display = 'block'; 
                     messageContainer.innerHTML = '';
                     messageContainer.style.display = 'none';
                    return false;
                } else {
                    errorContainer.style.display = 'none'; 
                }
                if(imageFormats.includes(uploaded.type)) {
                    this.imageUploading = true;
                    const reader = new FileReader();
                    this.imageHide = true;
                    //const productImage = document.getElementById('product-image');
                    //this.imageContainerHeight = productImage.naturalHeight;


                    messageContainer.innerHTML = '';
                    messageContainer.style.display = 'none';
                    reader.addEventListener('load', (readerEvent) => {
                        let image = new Image();
                        let ratio = 1;
                        image.onload = (imageEvent) => {

                            // Resize the image
                            var canvas = document.createElement('canvas'),
                                max_size = 1200,
                                width = image.width,
                                height = image.height;
                            if (width > height) {
                                if (width > max_size) {
                                    height *= max_size / width;
                                    width = max_size;
                                }
                            } else {
                                if (height > max_size) {
                                    width *= max_size / height;
                                    height = max_size;
                                }
                            }
                            canvas.width = width;
                            canvas.height = height;
                            this.imageWidth = width;
                            this.imageHeight = height;
                            this.imageRatio = ratio;
                            resizer.resize(image, canvas)
                                .then(() => {
                                    ratio = Math.round(width/height*100)/100;
                                    this.item.upload = canvas.toDataURL('image/jpeg');
                                    this.item.url = this.item.upload;
                                    document.getElementById('cropped-image').value = this.item.upload;

                                }).then(() => {
                                    return this.generateCroppedImage(canvas);
                                }).finally(() => {
                                    this.imageUploading = false;
                                    this.imageHide = false;
                                    this.imageContainerHeight = 0;
                                    this.imageUploaded = true;
                                    const eventD = new CustomEvent("destroyCropper");
                                    window.dispatchEvent(eventD);
                                    const updatedItem = this.resetItemOptions({'ratio': ratio});
                                    this.item.size = updatedItem.size;
                                    this.item.ratio = ratio;
                                    this.item.width = updatedItem.width;
                                    this.item.height = updatedItem.height;
                                    this.item.sizes = updatedItem.sizes;
                                    this.item.orientation = updatedItem.orientation;
                                    this.selectedImage = 0;
                                    messageContainer.innerHTML = 'Image uploaded successfully.';
                                    messageContainer.style.display = 'block';
                                });
                        }
                        image.src = readerEvent.target.result;
                    });
                    reader.readAsDataURL(this.files[0]);
                }

            }
        },
        downloadImage(image) {
            this.item.url = image;
            const productImage = document.querySelector('.product-main-img .img-responsive');
            this.imageWidth = productImage.naturalWidth;
            this.imageHeight = productImage.naturalHeight;
            this.imageRatio = this.imageWidth / this.imageHeight;
        },
        openQuickview() {
            const modalBody =`<div class="image"><img src="${this.item.url}" alt=""></div>`;
            store.dispatch('modal/set', {
                'modalBody': modalBody
            })
            this.openModal();
        },
        openUploadTips() {
            const modalBody =`<h3>Browse For Your Image</h3>
                    <p>We will accept the following file types for online orders: .jpg, .png, .bmp.</p>
                    <p>We also can use .psd, .psb, .eps, .ai, .tiff, or .pdf files. Please <a href="/pages/contact" target="_blank">contact us</a> or call us at 888-722-3674 for instructions to send your files.</p>
                    <p>Please call us at 888-722-3674 or <a href="/pages/contact" target="_blank">contact us</a> for assistance with other files types.</p>`;
            store.dispatch('modal/set', {
                'modalClass': 'modal-tips',
                'modalBody': modalBody
            })
            this.openModal();
        },
        openModal() {
            store.dispatch('modal/open')
        },
        closeModal() {
            store.dispatch('modal/close')
        },
        changeImage(index) {
            this.selectedImage = index;
        },
        selectCustom() {
            if(this.item.size !== 'custom') {
                this.item.size = 'custom';
            }
        },
        convertInches(dim) {
            const realFeet = this.feetAndInchesToRealFeet(this.item.sizes['custom'][dim].feet, this.item.sizes['custom'][dim].inches);
            const feetAndInches = this.realFeetToFeetAndInches(realFeet);
            this.item.sizes['custom'][dim].feet = feetAndInches.feet;
            this.item.sizes['custom'][dim].inches = feetAndInches.inches;
        },
        validateInputs(dim,unit) {
            this.errors = {};
            if(isNaN(this.item.sizes['custom'][dim][unit])) {
                this.item.sizes['custom'][dim][unit] = null;
            }
            this.selectCustom();
            if(unit === 'inches') {
                this.convertInches(dim);
            }
        },
        bwImage() {
            setTimeout(() => {
                let images = document.querySelectorAll('.product-img img:not(.product-thumb)');
                if(this.item.options.bw === false) {
                    images.forEach((image) => {
                        image.classList.remove('desaturate');
                    })
                } else {
                    images.forEach((image) => {
                        image.classList.add('desaturate');
                    })
                }
            },250);
        },
        flipImage() {
            if(this.cropperAdapter && this.cropperAdapter.isBuilt) {
                const originalData = this.cropperAdapter.getData();
                const cropBox = document.querySelector('.cropper-crop-box');
                let topPos = originalData.y;
                let leftPos = originalData.x;
                let width = 0;
                let height = 0;
                if(cropBox) {
                    topPos = cropBox.style.top;
                    leftPos = cropBox.style.left;
                    width = cropBox.style.width;
                    height = cropBox.style.height;
                }
                if(this.item.options.flip === false) {
                    this.cropperAdapter.unflip();
                } else {
                    this.cropperAdapter.flip();
                }
                this.customSizes.x = leftPos;
                this.customSizes.y = topPos;
                if(width && height) {
                    this.customSizes.flipWidth = width;
                    this.customSizes.flipHeight = height;
                }
                this.cropperAdapter.updateForUserDimensions(this.customSizes);
                const event = new CustomEvent("image.updated");
                this.productImage.dispatchEvent(event);
            }
            setTimeout(() => {
                let images = document.querySelectorAll('.product-img img:not(.product-thumb)');
                if(this.item.options.flip === false) {
                    images.forEach((image) => {
                        image.classList.remove('mirror');
                    });
                } else {
                    images.forEach((image) => {
                        image.classList.add('mirror');
                    });
                }
            },250);
        },
        getSizes(model) {
            let sizes = {
                'small': {},
                'medium': {},
                'large': {},
                'custom': {}
            };
            for(const size in sizes) {
                if(size === 'small') {
                    const realWidth = this.widthFromArea(this.smallSizeArea,model.ratio);
                    const width = this.realFeetToFeetAndInches(realWidth);
                    const height = this.realFeetToFeetAndInches(this.heightFromWidth(realWidth,model.ratio));

                    // Round Small Size to 59"
                    const widthInches = width.feet*12 + width.inches;
                    const heightInches = height.feet*12 + height.inches;
                    if(widthInches >= 59 && widthInches <= 62 && heightInches > 60) {
                        width.feet = 4;
                        width.inches = 10;
                    } else if (heightInches >= 59 && heightInches <= 62 && widthInches > 60) {
                        height.feet = 4;
                        height.inches = 10;
                    }
                    sizes[size] = {
                        "width": width,
                        "height": height,
                    }
                } else if(size === 'custom') {
                    sizes[size] = {
                        "width": {
                            "feet": null,
                            "inches": null
                        },
                        "height": {
                            "feet": null,
                            "inches": null
                        },
                    }
                } else {
                    let realWidth = 0;
                    if(size === 'medium') {
                        realWidth = this.widthFromArea(this.mediumSizeArea,model.ratio);
                    } else {
                        realWidth = this.widthFromArea(this.largeSizeArea,model.ratio);
                    }
                    const width = this.realFeetToFeetAndInches(realWidth);
                    const height = this.realFeetToFeetAndInches(this.heightFromWidth(realWidth,model.ratio));
                    sizes[size] = {
                        "width": width,
                        "height": height,
                    }
                }
            }
            return sizes;
        },
        getSizeLabel(size) {
            return `${this.item.sizes[size].width.feet}'${this.item.sizes[size].width.inches}" W x ${this.item.sizes[size].height.feet}'${this.item.sizes[size].height.inches}" H`;
        },
        widthFromArea(area,ratio) {
            return Math.round(Math.sqrt((1*ratio) * (1*area)) * 100)/100;
        },
        heightFromWidth(width,ratio) {
            return Math.round(this.ratioGetHeight(width,ratio) * 100)/100;
        },
        ratioGetHeight(width, ratio) {
            return width/ratio;
        },
        realFeetToFeetAndInches(realFeet) {
            let feet = Math.floor(realFeet);
            let inches = Math.round((realFeet - feet) * 12);
            if(inches === 12) {
                inches = 0;
                feet = feet+1;
            }
            return { "feet": feet, "inches": inches};
        },
        feetAndInchesToRealFeet(feet, inches) {
            return feet + (inches / 12);
        },
        getShopifyData() {
            try {
                this.shopify = JSON.parse(document.getElementById('product-json').textContent);
                const data = JSON.parse(document.getElementById('product-materials-json').textContent);
                this.materials = data.materials;
            } catch (e) {
                console.error(e)
            }
        },
        getItem() {
            let image = null
            let title = 'Wall Mural'
            let updateImage = false
            let imageId = null
            let urlKey = null
            let productId = null
            let categoryName = null
            let material = 'Fabric (peel and stick)'
            const params = new URLSearchParams(window.location.search);
            const url = new URL(window.location);
            if(params.has('imageId') === true) {
                imageId = parseInt(params.get('imageId'))
            } else {
                let urlId = url.pathname.replace('/products/mural/','');
                if(/^\d+$/.test(urlId)) {
                    imageId = parseInt(urlId);
                } else {
                    urlKey = urlId;
                    if(urlKey.indexOf('_') >= 0) {
                        let splitUrlKey = urlKey.split('_');
                        urlKey = splitUrlKey[0];
                        if(/^\d+$/.test(splitUrlKey[1])) {
                            productId = parseInt(splitUrlKey[1]);
                        }
                    }
                }

            }
            if(params.has('updateImage') === true) {
                updateImage = true
            }
            if(params.has('image') === true) {
                try {
                    image = atob(params.get('image'))
                } catch (e) {
                    console.error(e);
                }
            }
            if(params.has('title') === true) {
                try {
                    title = this.capitalize(atob(params.get('title')))
                    title = title.replace(/\./g, ' ');
                    if(title.indexOf('Wallpaper') === -1 && title.indexOf('Wall Mural') === -1) {
                        title = title + ' Wall Mural';
                    }
                } catch (e) {
                    console.error(e);
                }
            }

            if(params.has('category') === true) {
                try {
                    categoryName = this.capitalize(atob(params.get('category')))
                    categoryName = categoryName.replace(/\./g, ' ');
                } catch (e) {
                    console.error(e);
                }
            }

            // API product
            if(image) {
                this.validateStopWords({title: title},true)
                    .then((response) => {
                        if(!response) {
                            window.location.href = '/not-found';
                            return false;
                        } else {
                            return response;
                        }
                    }).then((response) => {
                        if(response) {
                            const img = new Image();
                            img.onload = () => {
                                const width = img.width
                                const height = img.height
                                const imageRatio = width / height
                                this.item = {
                                    "id": imageId,
                                    "url": image,
                                    "original_image": image,
                                    "title": title,
                                    "categories": categoryName ? [{'name': categoryName}] : [],
                                    "update": updateImage,
                                    "type": this.type,
                                    "width": width,
                                    "imageWidth": width,
                                    "height": height,
                                    "imageHeight": height,
                                    "ratio": imageRatio,
                                    "material": material,
                                    "instructions": '',
                                    "options": {
                                        "topcoat": false,
                                        "cover": false,
                                        "bw": false,
                                        "flip": false
                                    }

                                }
                                this.fetchCategory();
                                this.resetItemOptions(this.item);
                                this.updateMetas(this.item);
                                this.loaded = true;
                            }
                            img.src = image
                        }
                    });
            } else if(urlKey) {
                // Custom Uploader
                if(urlKey === 'custom') {
                    const img = new Image();
                    img.onload = () => {
                        const width = img.width
                        const height = img.height
                        const imageRatio = width / height
                        this.item = {
                            "custom": true,
                            "id": null,
                            "url": window.previewImageUrl,
                            "original_image": window.previewImageUrl,
                            "url_key": urlKey,
                            "categories": [{'name':'Custom Image'}],
                            "title": 'Customized Image Upload Wall Mural',
                            "meta_title": 'Customized Image Upload Wall Mural',
                            "meta_description": 'This product is used to manage customized image upload product configuration',
                            "description": 'Customized Image Upload Wall Mural',
                            "update": false,
                            "type": this.type,
                            "width": width,
                            "imageWidth": width,
                            "height": height,
                            "imageHeight": height,
                            "ratio": imageRatio,
                            "upload": window.previewImageUrl,
                            "material": material,
                            "instructions": '',
                            "options": {
                                "topcoat": false,
                                "cover": false,
                                "bw": false,
                                "flip": false
                            }
                        }
                        this.resetItemOptions(this.item);
                        this.updateMetas(this.item);
                        this.loaded = true;
                    }
                    img.src = window.previewImageUrl;


                // Magento Product
                } else {
                    let url = this.remoteApiUrl + 'shopify/api/load?isAjax=1&type=mural&url='+urlKey;
                    if(productId) {
                        url += '&entity_id=' + productId;
                    }
                    axios.get(url)
                        .then((response) => {
                            if(response.data && response.data.product) {
                                const test = response.data.product;
                                return this.validateStopWords(test,response);
                            } else {
                                return response;
                            }
                        })
                        .then((response) => {
                            if(!response || !response.data || !response.data.product) {
                                window.location.href = '/not-found';
                                return false;
                            } else {
                                return response;
                            }
                        })
                        .then((response) => {
                            if(response && response.data && response.data.product) {
                                const product = response.data.product;
                                if(product.hasOwnProperty('type') && product['type'] !== 'mural') {
                                    // redirect to correct typy
                                    window.location.href = '/products/'+product['type']+'/'+product['url'];
                                    return false;
                                }
                                if(product.hasOwnProperty('default_material')) {
                                    const found = this.materials.find(m => m.code === product['default_material']);
                                    if(found) {
                                        material = found.label
                                    }
                                }
                                const img = new Image();
                                img.onload = () => {
                                    const width = img.width
                                    const height = img.height
                                    const imageRatio = width / height
                                    this.item = {
                                        "entity_id": product.entity_id,
                                        "sku": product.sku,
                                        "similar_categories": product.similar_categories,
                                        "categories": product.similar_categories,
                                        "id": product.id,
                                        "url": product.thumbnail_url,
                                        "original_image": product.thumbnail_url,
                                        "url_key": productId ? urlKey+'_'+productId : urlKey,
                                        "title": product.title,
                                        "meta_title": product.meta_title,
                                        "meta_description": product.meta_description,
                                        "additional_info": product.additional_info,
                                        "description": product.description,
                                        "update": false,
                                        "dmi": product.hasOwnProperty('dmi') && product.dmi ? product.dmi : null,
                                        "type": this.type,
                                        "width": width,
                                        "imageWidth": width,
                                        "height": height,
                                        "imageHeight": height,
                                        "ratio": imageRatio,
                                        "material": material,
                                        "instructions": '',
                                        "options": {
                                            "topcoat": false,
                                            "cover": false,
                                            "bw": false,
                                            "flip": false
                                        }
                                    }
                                    this.resetItemOptions(this.item);
                                    this.updateMetas(this.item);
                                    this.loaded = true;
                                }
                                img.src = product.thumbnail_url
                            } else {
                                window.location.href = '/products/mural/custom';
                                return false;
                            }
                        }).finally(() => {

                        });
                }
            // API Product with Image ID only
            } else if(imageId) {
                let url = this.remoteApiUrl + 'shopify/api/get?isAjax=1&type=mural&id='+imageId;
                axios.get(url)
                    .then((response) => {
                        if(response.data && response.data.product) {
                            const test = response.data.product;
                            return this.validateStopWords(test,response);
                        } else {
                            return response;
                        }
                    })
                    .then((response) => {
                        if(!response || !response.data || !response.data.product) {
                            window.location.href = '/not-found';
                            return false;
                        } else {
                            return response;
                        }
                    })
                    .then((response) => {
                        if(response.data && response.data.product) {
                            const product = response.data.product;
                            if(product.hasOwnProperty('default_material')) {
                                const found = this.materials.find(m => m.code === product['default_material']);
                                if(found) {
                                    material = found.label
                                }
                            }
                            const img = new Image();
                            img.onload = () => {
                                const width = img.width
                                const height = img.height
                                const imageRatio = width / height
                                this.item = {
                                    "id": product.id,
                                    "url": product.thumbnail_url,
                                    "original_image": product.thumbnail_url,
                                    "title": product.title,
                                    "categories": product.hasOwnProperty('category') && product.category ? product.category : [],
                                    "update": false,
                                    "type": this.type,
                                    "width": width,
                                    "imageWidth": width,
                                    "height": height,
                                    "imageHeight": height,
                                    "ratio": imageRatio,
                                    "material": material,
                                    "instructions": '',
                                    "options": {
                                        "topcoat": false,
                                        "cover": false,
                                        "bw": false,
                                        "flip": false
                                    }
                                }
                                this.resetItemOptions(this.item);
                                this.updateMetas(this.item);
                                this.loaded = true;
                            }
                            img.src = product.thumbnail_url
                        }
                    }).catch((error) => {
                        let filters = this.cloneObject(this.xApiFilters);
                        filters['search_parameters']['thumbnail_size'] = 1000;
                        filters['search_parameters']['media_id'] = imageId;
                        fetch(this.adobeApiSearchUrl, {method: 'POST', body: JSON.stringify(filters), headers: this.fetchHeaders})
                            .then((response) => response.json())
                            .then((response) => {
                                if(response && response.files && response.files.length > 0) {
                                    const product = response.files[0];
                                    const img = new Image();
                                    img.onload = () => {
                                        const width = img.width
                                        const height = img.height
                                        const imageRatio = width / height
                                        this.item = {
                                            "id": product.id,
                                            "url": product.thumbnail_url,
                                            "original_image": product.thumbnail_url,
                                            "title": product.title,
                                            "categories": [],
                                            "update": false,
                                            "type": this.type,
                                            "width": width,
                                            "imageWidth": width,
                                            "height": height,
                                            "imageHeight": height,
                                            "ratio": imageRatio,
                                            "material": material,
                                            "instructions": '',
                                            "options": {
                                                "topcoat": false,
                                                "cover": false,
                                                "bw": false,
                                                "flip": false
                                            }
                                        }
                                        this.resetItemOptions(this.item);
                                        this.updateMetas(this.item);
                                        this.loaded = true;
                                    }
                                    img.src = product.thumbnail_url
                                }
                            })
                    }).finally(() => {

                    });
            }
        },
        resetItemOptions(model) {
            const sizes = this.getSizes(model);
            model['size'] = 'small';
            model['width'] = this.cloneObject(sizes['small']['width']);
            model['height'] = this.cloneObject(sizes['small']['height']);
            model.sizes = this.cloneObject(sizes);
            model.sizes['custom']['width'] = this.cloneObject(model['width']);
            model.sizes['custom']['height'] = this.cloneObject(model['height']);
            model.orientation = 'horizontal';
            if(model.ratio <= 0.85) {
                model.orientation = 'vertical';
            } else if(model.ratio > 0.85 && model.ratio <= 1.1) {
                model.orientation = 'square';
            } else if(model.ratio >= 2) {
                model.orientation = 'panoramic';
            }
            return model;
        },
        fetchCategory() {
            if(this.item && this.item.hasOwnProperty('id') && this.item.id) {
                fetch(this.adobeApiMetadataUrl, {method: 'POST', body: JSON.stringify({'id': this.item.id}), headers: this.fetchHeaders})
                    .then((response) => response.json())
                    .then((response) => {
                        if(response && response.hasOwnProperty('files') && response['files'] && response['files'].length > 0) {
                            response['files'].forEach((resultFile) => {
                                if(resultFile.hasOwnProperty('id') &&
                                    resultFile.id === this.item.id &&
                                    resultFile.hasOwnProperty('category') &&
                                    resultFile['category'] &&
                                    resultFile['category'].hasOwnProperty('name'))
                                {
                                    this.item.categories.push(resultFile['category']);
                                }
                            })
                        }
                    })
                    .catch((error) => console.error(error));
            }

        },
        openSampleModal() {
            this.hasSampleImage = true;
            if(this.item.custom === true && !this.croppedFiles) {
                this.hasSampleImage = false;
                return false;
            }
            store.dispatch('samplePopup/set', {'item': this.item, 'croppedFile': this.croppedFiles, 'files': this.files});
            store.dispatch('samplePopup/open');
        },
        addToCart() {
            this.errors = {};
            if(isNaN(this.qty) || this.qty < 1 || !this.variant) {
                this.errors['cart'] = 'Please select mural size';
                return false;
            }
            let properties = {
                '_id': this.item.custom ? 'custom' : this.item.id,
                '_entity_id': this.item.hasOwnProperty('entity_id') && this.item.entity_id ? this.item.entity_id : null,
                '_sku': this.item.hasOwnProperty('sku') && this.item.sku ? this.item.sku : this.item.custom ? 'custom' : this.item.id,
                '_original_image': this.item.original_image,
                '_product_url': window.location.href.split('?')[0],
                '_cropped_image': document.getElementById('cropped-image').value,
                '_url_key': this.item.hasOwnProperty('url_key') && this.item.url_key ? this.item.url_key : null,
                '_name': this.item.title,
                '_quantity': 1,
                '_type': this.type,
                '_sq_ft': (this.qty * 144),
                '_bw': false,
                '_flip': false,
                '_coordinates': JSON.stringify(this.cropCoordinates),
                'Width': (this.item.width.feet ? this.item.width.feet : 0) + '\' ' + (this.item.width.inches ? this.item.width.inches : 0) + '"',
                'Height': (this.item.height.feet ? this.item.height.feet : 0) + '\' ' + (this.item.height.inches ? this.item.height.inches : 0) + '"',
                'Materials': this.item.material
            };
            let options = [];
            if(this.item.options.cover && this.item.options.cover !== '') {
                options.push(this.item.options.cover);
            };
            if(this.item.options.bw && this.item.options.bw !== '') {
                properties['_bw'] = true;
                options.push(this.item.options.bw);
            };
            if(this.item.options.flip && this.item.options.flip !== '') {
                properties['_flip'] = true;
                options.push(this.item.options.flip);
            };
            if(options.length > 0) {
                properties['Options'] = options.join(', ');
            }
            if(this.item.options.topcoat && this.item.options.topcoat !== '') {
                properties['Topcoat'] = this.item.options.topcoat;
            }
            if(this.item.instructions && this.item.instructions !== '') {
                properties['Comments'] = this.item.instructions;
            }
            if(this.files && this.files[0]) {
                properties['_uploaded_image'] = this.files[0];
            }
            if(this.croppedFiles) {
                properties['_cropped_image'] = this.croppedFiles;
            }

            const data = {
                items: [{
                    id: this.variant.id,
                    quantity: this.qty * 144,
                    properties: properties
                }],
                'sections': this.cartNotification.getSectionsToRender().map((section) => section.id),
                'sections_url': window.location.pathname
            };
            const additionalData = {
                specialPrice: this.specialPrice,
                correctedPrice: this.correctedPrice,
                productUrl: window.location.pathname.split('?')[0],
                size: properties['Width'] + ' x ' + properties['Height'],
                area: this.qty * 144,
                image: this.item.url
            }
            const formData = new FormData();
            formData.set('id',this.variant.id);
            formData.set('quantity',this.qty * 144);

            for(const key in properties) {
                formData.set(`properties[${key}]`,properties[key]);
            }

            const submitData = new FormData();
            submitData.set('id',properties['_id']);
            submitData.set('sku',properties['_sku']);
            submitData.set('type',this.item.type);
            submitData.set('title',this.item.title);
            submitData.set('size',additionalData['size']);
            submitData.set('correctedPrice',additionalData['correctedPrice']);
            submitData.set('area',additionalData['area']);
            submitData.set('image',additionalData['image']);
            if(this.croppedBlob) {
                submitData.set('blob',this.croppedBlob);
            }
            if(this.item.categories && this.item.categories.length > 0) {
                const categoryNames = this.item.categories.map(category => category.name);
                const uniqueCategoryNames = [...new Set(categoryNames)];
                submitData.set('tags',uniqueCategoryNames.join(','));
            }
            store.dispatch('cartPopup/submit', {
                'cart': data,
                'form': formData,
                'product': this.item,
                'additional': submitData,
                'sections': this.cartNotification.getSectionsToRender().map((section) => section.id),
                'sections_url': window.location.pathname
            });
            const productUrl = window.location.href.split('?')[0];
            const productData = {
                'pageType' : 'Add to Cart',
                'event'    : 'Add to Cart',
                'products': [{
                    'id': this.item.id,
                    'sku': this.item.id,
                    'productType': this.item.type,
                    'name': this.item.title,
                    'price': document.getElementById('hidden_product_price').value,
                    'imageURL': this.item.url,
                    'productURL': productUrl
                }]
            };
            this.updateDataLayer(productData);
        },
        getStaticImages() {
            try {
                const allStaticImages = JSON.parse(document.getElementById('product-static-images-metaobject').textContent);
                const muralStaticImages = allStaticImages
                    .filter(item => item.type === "mural")
                    .sort((a, b) => a.position - b.position)
                    .reduce((acc, item) => {
                        if (!acc[item.orientation]) acc[item.orientation] = []
                        acc[item.orientation].push(item)
                        return acc
                    }, {});
                // if this.item.custom === true, filter out images with type === 'custom mural', sort by position and add to the start of the array
                if(this.item && this.item.custom === true) {
                    const customMuralImages = allStaticImages
                        .filter(item => item.type === "custom mural")
                        .sort((a, b) => a.position - b.position);
                    for(const orientation in muralStaticImages) {
                        muralStaticImages[orientation] = [...customMuralImages, ...muralStaticImages[orientation]];
                    }
                }
                this.staticImages = muralStaticImages;
            } catch (e) {
                console.error(e)
            }
        },
        openCompareModal() {
            store.dispatch('modal/openComparePopup');
        },
        closeCompareModal() {
            store.dispatch('modal/closeComparePopup');
        },
    },
}, { ...rootEl.dataset })
const faqsApp = Vue.createApp({
    components: {
        'faqs': Faqs,
    }
});
productApp.use(AdobeClientPlugin).use(store);
productApp.config.compilerOptions.isCustomElement = tag => tag.includes('-') && !tag.includes('router') && !tag.includes('api') && !tag.includes('additional-info') && !tag.includes('materials-compare')
productApp.config.unwrapInjectedRef = true
productApp.config.globalProperties.smallSizeArea = 9;
productApp.config.globalProperties.mediumSizeArea = 62;
productApp.config.globalProperties.largeSizeArea = 96;
productApp.config.globalProperties.minPrice = 10000;
document.addEventListener('DOMContentLoaded', function () {
    productApp.mount('#productApp');
    faqsApp.mount('#faqsApp');
});
